import { coreAPI } from "../../axios";


export const actions = {
    GetSubmissionDeadline(context, data){
        return coreAPI.get(`SubmissionDeadline/All/${data}`);
    },
    UpdateSubmissionDeadline(context, data){
        return coreAPI.put(`SubmissionDeadline/Update/${data.id}`, data);
    },
    DeleteSubmissionDeadline(context, data){
        return coreAPI.delete(`SubmissionDeadline/Delete/${data}`);
    },
    CreateSubmissionDeadline(context, data){
        return coreAPI.post(`SubmissionDeadline/Add`, data);
    }
}